import React, { useEffect, useState } from 'react';
import '../styles/rowProperties.css';

const formatDateTime = (iso) => (iso
  ? new Date(iso).toLocaleString('es-EC', { dateStyle: 'medium', timeStyle: 'short' })
  : '—');

// ℹ️ row button that shows who created / last edited a row, and when.
// `item` needs created_by_username, created, last_edited_by_username and modified (from the API).
export default function RowProperties({ item, title }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const rows = [
    ['Creado por', item.created_by_username || '—'],
    ['Fecha de creación', formatDateTime(item.created)],
    ['Editado por', item.last_edited_by_username || '—'],
    ['Última modificación', formatDateTime(item.modified)],
  ];

  return (
    <>
      <button
        type="button"
        className="row-icon-btn"
        onClick={() => setOpen(true)}
        title="Propiedades"
        aria-label="Propiedades"
      >
        ℹ️
      </button>
      {open && (
        <div className="row-props-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className="row-props-dialog" role="dialog" aria-modal="true" aria-label={`Propiedades: ${title}`}>
            <div className="row-props-header">
              <div>
                <div className="row-props-title">Propiedades</div>
                <div className="row-props-subtitle">{title}</div>
              </div>
              <button type="button" className="row-props-close" onClick={() => setOpen(false)} aria-label="Cerrar">✖️</button>
            </div>
            <dl className="row-props-list">
              {rows.map(([label, value]) => (
                <div key={label} className="row-props-row">
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      )}
    </>
  );
}
